import { render, staticRenderFns } from "./TabelaUsuarios.vue?vue&type=template&id=35c11c0a&scoped=true&lang=pug"
import script from "./TabelaUsuarios.vue?vue&type=script&lang=js"
export * from "./TabelaUsuarios.vue?vue&type=script&lang=js"
import style0 from "./TabelaUsuarios.vue?vue&type=style&index=0&id=35c11c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c11c0a",
  null
  
)

export default component.exports